import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wbc_access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function apiError(error) {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item.message || item.msg || item).join(" · ");
  }
  return detail || "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.";
}

// Liefert bei feldbezogenen 422-Antworten des Backends ein Map<feld, nachricht>.
// Format: [{field, message}, ...] (vom Backend so gesendet).
export function apiFieldErrors(error) {
  const detail = error?.response?.data?.detail;
  if (!Array.isArray(detail)) return null;
  const map = {};
  for (const item of detail) {
    if (item && typeof item === "object" && item.field && item.message) {
      map[item.field] = item.message;
    }
  }
  return Object.keys(map).length ? map : null;
}
